import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { mergeDeep } from '../services/Utils';

import dataFromCms from './cmsTranslations.json';

const appTranslations = {
  'en-GB': {
    translation: {
      'Select a product to see performance breakdown':
        'Select a product to see performance breakdown',
      'Search for a product': 'Search for a product',
      'Performance data for this product is currently not available. If you believe this to be an error please contact us.':
        'Performance data for this product is currently not available. If you believe this to be an error please contact us.',
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      Date: 'Date',
      Resources: 'Resources',
      StrikeTime: 'Strike Time',
      'Index rebased to 100': 'Index rebased to 100',
      'Daily % return': 'Daily % return',
      'Implied Leverage': 'Implied Leverage',
    },
  },
  'it-IT': {
    translation: {
      'Select a product to see performance breakdown':
        "Selezionare un prodotto per vedere l'analisi dettagliata della performance.",
      'Search for a product': 'Cerca un prodotto',
      'Performance data for this product is currently not available. If you believe this to be an error please contact us.':
        'I dati relativi alla performance di questo prodotto non sono attualmente disponibili. Se ritenete che questo sia un errore, vi invitiamo a contattarci.',
      months: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre',
      ],
      Date: 'Data',
      Resources: 'Risorse',
      StrikeTime: 'Orario di rilevazione',
      'Index rebased to 100': 'Indice ribasato a 100',
      'Daily % return': '% di rendimento giornaliero',
      'Implied Leverage': 'Leva implicita',
    },
  },
  'de-DE': {
    translation: {},
  },
};

i18next.use(initReactI18next).init({
  interpolation: {
    // React already does escaping
    escapeValue: false,
  },
  lng: 'en-GB',
  fallbackLng: {
    'it-CH': ['it-IT', 'en-GB'],
    'de-CH': ['de-DE', 'en-GB'],
    'de-AT': ['de-DE', 'en-GB'],
    default: ['en-GB'],
  },
  resources: mergeDeep(appTranslations, dataFromCms),
});

export default i18next;
